module.exports = __webpack_public_path__ + "static/media/other-loan-or-credit-income.de608e65.svg";